import type { TSerializedWidget } from 'src/entities/workspace/types';
import type { AlertsManagerWidgetEntity } from 'src/pages/dashboard/features/alerts-manager-widget/AlertsManagerWidget.entity';
import { parseAlertsManagerWidgetInternalState } from 'src/pages/dashboard/features/alerts-manager-widget/parseAlertsManagerWidget';

import { baseWidgetApplyChanges } from './baseWidgetApplyChanges';

export function alertsManagerApplyChanges(
  widget: AlertsManagerWidgetEntity,
  changes: TSerializedWidget,
  index: number,
) {
  baseWidgetApplyChanges(widget, changes, index);

  const internalState = parseAlertsManagerWidgetInternalState(changes.internalState);

  widget.setWellId(internalState.wellId);
  widget.setStateParams(internalState.stateParams);
}
